module.exports = __webpack_public_path__ + "static/media/blog_img6.2333c33e.jpg";